import { ReactNode, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

export default function Done(): ReactNode {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const intentId = searchParams.get("payment_intent");

  useEffect(() => {
    if (!intentId) {
      navigate("/failed", { replace: true });

      return;
    }

    fetch(`/api/pay/verify/${intentId}`)
      .then((resp) => {
        if (resp.status >= 400) {
          navigate("/failed", { replace: true });
          return;
        }

        resp
          .text()
          .then((url) => {
            navigate(url, { replace: true });
          })
          .catch((err) => {
            console.error(err);
            navigate("/error", { replace: true });
          });
      })
      .catch((err) => {
        console.error(err);
        navigate("/error", { replace: true });
      });
  }, []);

  return (
    <article className="container h-100 vh-100">
      <section className="text-center row justify-content-center align-items-center h-100 vh-100">
        <article
          className="inline-block self-center w-8 h-8 rounded-full border-4 border-current border-solid animate-spin border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
          role="status"
        >
          <span className="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]">
            Loading...
          </span>
        </article>
        <p>Verifying Order...</p>
      </section>
    </article>
  );
}
